export default __webpack_public_path__ + "static/media/Reportes.2001c363.svg";